import { useState } from "react";

const ChatLinesLoader = ({ search=true, cardCount = 5 }) => {
    const [lines] = useState(() =>
        Array.from({ length: cardCount }).map(() => ({
            width: Math.floor(Math.random() * (100 - 30 + 1) + 30),
            duration: (Math.random() * 2 + 3).toFixed(2) + "s",
            delay: (Math.random() * 1).toFixed(2) + "s"
        }))
    );

    return (
        <div className="item_loader">
            <div className="item_loader_body_code">
                {lines.map((line, index) => (
                    <div
                        key={index}
                        className="item_loader_code_line animate-width"
                        style={{
                            width: `${line.width}%`,
                            animationDuration: line.duration,
                            animationDelay: line.delay,
                        }}
                    />
                ))}
                {search && (
                    <div className="item_laoder_search_cont">
                    {Array.from({ length: 4 }).map((_, index) => (
                        <div key={index} className="item_laoder_search_cont_item" />
                    ))}
                </div>
                )}
            </div>
        </div>
    );
};

export default ChatLinesLoader;